<div id="login-container">
  <div id="cover"></div>
  <div id="login">
    <img
      ngSrc="../../../../assets/images/sollo-logo.svg"
      height="43"
      width="116"
      alt="Sollo"
      style="height: auto"
      draggable="false"
      priority="high"
    />
    <form #loginForm="ngForm" (ngSubmit)="onLogin()">
      <mat-form-field appearance="fill">
        <mat-label>{{ "FORMS.email" | translate }}</mat-label>
        <input type="email" matInput [(ngModel)]="email" name="email" />
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>{{ "FORMS.password" | translate }}</mat-label>
        <input
          type="password"
          matInput
          [(ngModel)]="password"
          name="password"
        />
      </mat-form-field>

      <button mat-raised-button color="accent">
        {{ "FORMS.login" | translate }}
      </button>
    </form>
  </div>
</div>
